import { api } from '../config'

export const NOTIFICATIONS_URL = {
  sendNotification: `${api.withAPI}/admin/notification/all`,
}
